import { createFileRoute } from '@tanstack/react-router';
import { ContractsPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/contracts/')({
  component: ContractsRoute,
});

function ContractsRoute() {
  const { orgId } = Route.useParams();
  return <ContractsPage orgId={orgId} />;
}
